module.exports = __webpack_public_path__ + "img/CONNECTED.4242a43f.svg";